import scrollTo from './animation/scrollTo';
import forEachSelector from './elements/forEachSelector';
import addStartupScript from './events/addStartupScript';
import addClickHandler from './events/addClickHandler';

// Focus on the given element
function autoFocus(el) {
  el && el.focus();
}

// Dispatch a 'scrollTo.complete' event from the target element
function dispatchCompleteEvent(el) {
  const event = document.createEvent('Event');
  event.initEvent('scrollTo.complete', true, true);
  el.dispatchEvent(event);
}

export function setup() {
  forEachSelector('.js-scroll-trigger', trigger => {
    const {
      target,
      focus,
      speed
    } = trigger.dataset;

    function triggerScroll() {
      // Animate the page to scroll to the targeted scroll position
      scrollTo(document.querySelector(target), speed, function () {
        dispatchCompleteEvent(trigger);
        autoFocus(document.querySelector(focus));
      });
    }

    addClickHandler(trigger, function (e) {
      e.preventDefault();
      triggerScroll();
    });
  });
}

addStartupScript(setup);
